var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { Benefit } from '../data/benefit';
import { Condition } from '../data/condition';
import { Discount } from '../data/discount';
import { DiscountManager } from './discount-manager';
import { OrderManager } from './order-manager';
// import { OrderService } from '../services/order.service';
var MultiOrderManager = /** @class */ (function () {
    function MultiOrderManager(discountManager) {
        this.discountManager = discountManager;
        this.enableMutlOrder = false;
        this.storesMap = {};
        this.sumDiscount = 0;
        this.amountDiscount = {};
        this.orderDisountMap = {};
        this.orderManagerMap = {};
        this.currentPeriods = {};
    }
    MultiOrderManager.prototype.setOrderManagerMap = function (orderManager, storeId) {
        this.orderManagerMap[storeId] = orderManager;
    };
    MultiOrderManager.prototype.calOrderWithDiscount = function () {
        var orders = this.getOrders() || [];
        //init discount map 
        this.orderDisountMap = {};
        if (orders.length > 0 && this.courtDiscount) {
            this.amountDiscount = {};
            var _loop_1 = function (i) {
                // delete empty orderItem orderManager
                //    if (orders[i].orderitems && orders[i].orderitems.length === 0) {
                //     this.deleteOrderManager(orders[i].storeId);
                //     continue;
                //    }
                var storeId = orders[i].storeId;
                var discounts = this_1.getAvailableDiscount(this_1.courtDiscount, orders[i].brandId, orders[i]) || [];
                var tableLog = [['name', 'brandId', 'conditions', 'group/priority']];
                discounts.map(function (d) {
                    tableLog.push(["" + d.name, "" + (d.brandIds || 'null'), "" + JSON.stringify(d.conditions), "" + (d.group + '/' + d.priority)]);
                });
                console.table(tableLog);
                orders[i].promotions = discounts;
                discounts.length > 0 && this_1.discountManager.applyOrderPromotions(orders[i], discounts, this_1.getOrderManager(storeId), this_1.checkIsStaff(), this_1, true);
            };
            var this_1 = this;
            // for (let i = 0; i < orders.length; i++) {
            for (var i = orders.length - 1; i >= 0; i--) {
                _loop_1(i);
            }
            this.getSumDiscount();
        }
    };
    MultiOrderManager.prototype.applyOrdersDiscount = function (orders) {
        if (orders.length > 0 && this.courtDiscount) {
            this.amountDiscount = {};
            var _loop_2 = function (i) {
                // delete empty orderItem orderManager
                //    if (orders[i].orderitems && orders[i].orderitems.length === 0) {
                //     this.deleteOrderManager(orders[i].storeId);
                //     continue;
                //    }
                var storeId = orders[i].storeId;
                var discounts = this_2.getAvailableDiscount(this_2.courtDiscount, orders[i].brandId, orders[i]) || [];
                var tableLog = [['name', 'brandId', 'conditions', 'group/priority']];
                discounts.map(function (d) {
                    tableLog.push(["" + d.name, "" + (d.brandIds || 'null'), "" + JSON.stringify(d.conditions), "" + (d.group + '/' + d.priority)]);
                });
                console.table(tableLog);
                this_2.discountManager.applyOrderPromotions(orders[i], discounts, null, this_2.checkIsStaff(), this_2, true);
            };
            var this_2 = this;
            // for (let i = 0; i < orders.length; i++) {
            for (var i = orders.length - 1; i >= 0; i--) {
                _loop_2(i);
            }
            var total_1 = 0;
            orders.length > 0 && orders.map(function (order) {
                if (order.discount > 0)
                    total_1 += order.discount;
            });
            this.sumDiscount = Number(total_1.toFixed(2));
            return Number(total_1.toFixed(2));
        }
    };
    MultiOrderManager.prototype.checkIsStaff = function () {
        var isStaff = false;
        //TODO court member?
        // return true;
        return isStaff;
    };
    MultiOrderManager.prototype.checkPromocodeAvailable = function (discountCode) {
        var isCodeType = false;
        this.courtDiscount.map(function (discount) {
            (discount.conditions || []).map(function (condition) {
                if (condition.type === 'code' && condition.code === discountCode) {
                    isCodeType = true;
                    // TODO: to check, push to order.promoCodes
                    // this.orderService.discountCode = discountCode;
                }
            });
        });
        if (!isCodeType) {
            // this.orderService.discountCode = '';
        }
        return isCodeType;
    };
    MultiOrderManager.prototype.getSumDiscount = function () {
        var orders = this.getOrders() || [];
        var total = 0;
        orders.length > 0 && orders.map(function (order) {
            if (order.discount > 0)
                total += order.discount;
        });
        this.sumDiscount = Number(total.toFixed(2));
        return Number(total.toFixed(2));
    };
    MultiOrderManager.prototype.initCourtDiscounts = function (discounts, menus) {
        var _courtDiscount = [];
        discounts.forEach(function (d) {
            var promo = new Discount();
            promo.level = d.level;
            promo.benefits = [];
            if (d.benefits) {
                d.benefits.forEach(function (b) {
                    // if (menu && b.type === 'unlock' && menu.unlocks) promo.unlocks = menu.unlocks;
                    // if (menu && b.type === 'gift' && menu.gifts) promo.gifts = menu.gifts;
                    // if(menus&&menus.length) {
                    //     menus.forEach((menu)=>{
                    //         if (menu && b.type === 'unlock' && menu.unlocks) promo.unlocks = menu.unlocks;
                    //         if (menu && b.type === 'gift' && menu.gifts) promo.gifts = menu.gifts;
                    //     })
                    // } 
                    promo.benefits.push(Benefit.cloneBenefit(b));
                });
            }
            promo.conditions = [];
            if (d.conditions) {
                d.conditions.forEach(function (c) {
                    promo.conditions.push(Condition.cloneCondition(c));
                });
            }
            if (menus && menus.length) {
                promo.unlocks = [];
                promo.gifts = [];
                menus.forEach(function (menu) {
                    if (menu && menu.unlocks)
                        promo.unlocks = promo.unlocks.concat(menu.unlocks);
                    if (menu && menu.gifts)
                        promo.gifts = promo.gifts.concat(menu.gifts);
                });
            }
            promo.name = d.name;
            promo.amount = d.amount;
            promo.available = d.available;
            promo.backendId = d.backendId;
            promo.brandIds = d.brandIds;
            promo.id = d.id;
            promo.enabled = d.enabled;
            promo.desc = d.desc;
            promo.quantity = d.quantity;
            promo.alone = d.alone;
            promo.priority = d.priority;
            promo.group = d.group;
            promo.disabledChannels = d.disabledChannels;
            _courtDiscount.push(promo);
        });
        this.courtDiscount = _courtDiscount;
    };
    MultiOrderManager.prototype.getAvailableDiscount = function (discounts, orderbrandId, order) {
        var _this = this;
        var availableDiscounts = [];
        discounts.map(function (discount) {
            if (!discount.brandIds || discount.brandIds.length == 0) { // 未set brandIds条件,即改discount适用与all brand
                // % apply for all, amount apply for one
                if (discount.benefits[0].type === "amount") {
                    if (!_this.amountDiscount[discount.id] && order && order.grandTotal >= discount.benefits[0].amount) {
                        _this.amountDiscount[discount.id] = orderbrandId;
                        availableDiscounts.push(discount);
                    }
                }
                else {
                    availableDiscounts.push(discount);
                }
            }
            else {
                discount.brandIds.map(function (brandId) {
                    brandId === orderbrandId && availableDiscounts.push(discount);
                });
            }
        });
        return availableDiscounts;
    };
    MultiOrderManager.prototype.getOrderManager = function (storeId) {
        return this.orderManagerMap[storeId];
    };
    MultiOrderManager.prototype.getOrderManagers = function () {
        var orderManager = [];
        for (var key in this.orderManagerMap) {
            orderManager.push(this.orderManagerMap[key]);
        }
        return orderManager;
    };
    MultiOrderManager.prototype.getOrders = function () {
        var orders = [];
        for (var key in this.orderManagerMap) {
            if (this.orderManagerMap[key].order.grandTotal || (this.orderManagerMap[key].order && this.orderManagerMap[key].order.orderitems.length > 0)) {
                orders.push(this.orderManagerMap[key].order);
            }
        }
        return orders;
    };
    MultiOrderManager.prototype.getStores = function () {
        var stores = [];
        for (var key in this.orderManagerMap) {
            if (this.orderManagerMap[key].order.grandTotal || (this.orderManagerMap[key].order && this.orderManagerMap[key].order.orderitems.length > 0)) {
                stores.push(this.orderManagerMap[key].store);
            }
        }
        return stores;
    };
    MultiOrderManager.prototype.getStore = function (storeId) {
        return this.orderManagerMap[storeId].store;
    };
    MultiOrderManager.prototype.clearAll = function () {
        this.orderManagerMap = {};
        this.currentPeriods = {};
    };
    MultiOrderManager.prototype.deleteOrderManager = function (storeId) {
        delete this.orderManagerMap[storeId];
    };
    MultiOrderManager.prototype.getOrderCount = function () {
        var orderManagers = this.getOrderManagers();
        var sum = 0;
        orderManagers.forEach(function (orderManager) {
            sum += orderManager.count;
        });
        return sum;
    };
    MultiOrderManager.prototype.getOrderTotal = function () {
        var orderManagers = this.getOrderManagers();
        var sum = 0;
        orderManagers.forEach(function (orderManager) {
            sum = Number((sum + orderManager.order.total).toFixed(2));
        });
        return sum;
    };
    MultiOrderManager.prototype.getOrderGrandTotal = function (notShowDiscountTotal) {
        if (notShowDiscountTotal === void 0) { notShowDiscountTotal = false; }
        var orderManagers = this.getOrderManagers();
        var sum = 0;
        orderManagers.forEach(function (orderManager) {
            var discount = 0;
            if (notShowDiscountTotal && orderManager.order.discount > 0) {
                discount = orderManager.order.discount;
            }
            sum = Number((sum + orderManager.order.grandTotal + discount).toFixed(2));
        });
        return sum;
    };
    MultiOrderManager.prototype.getOrderitemsTotal = function () {
        var orderManagers = this.getOrderManagers();
        var sum = 0;
        orderManagers.forEach(function (orderManager) {
            sum += orderManager.count;
        });
        return sum;
    };
    MultiOrderManager.prototype.setStoreCurrentOrderingPeriod = function (storeId, period) {
        this.currentPeriods[storeId] = period;
    };
    MultiOrderManager.prototype.deleteStoreCurrentOrderingPeriod = function (storeId) {
        delete this.currentPeriods[storeId];
    };
    MultiOrderManager.prototype.getStoresCurrentOrderingPeriod = function () {
        var periods = [];
        var storeIds = [];
        for (var key in this.currentPeriods) {
            periods.push(this.currentPeriods[key]);
            storeIds.push(Number(key));
        }
        return [periods, storeIds];
    };
    MultiOrderManager.prototype.initOrders = function (takeout) {
        var _this = this;
        if (takeout) {
            this.mode = 'takeout';
        }
        else {
            this.mode = 'dinein';
        }
        var storeIds = [];
        storeIds = this.stores.map(function (store) { return store.id; });
        // console.log(storeIds);
        storeIds.forEach(function (storeId) {
            if (!_this.getOrderManager(storeId)) {
                var orderManager = new OrderManager();
                orderManager.createOrder(storeId, takeout, null, "kiosk", _this.storesMap[storeId]);
                orderManager.setSource("kiosk");
                _this.setOrderManagerMap(orderManager, storeId);
            }
        });
    };
    //change dinein/takeaway, pop to root or payment finished
    MultiOrderManager.prototype.clearAllOrders = function () {
        var _this = this;
        var storeIds = [];
        storeIds = this.stores.map(function (store) { return store.id; });
        storeIds.forEach(function (storeId) {
            if (_this.getOrderManager(storeId)) {
                var orderManager = _this.getOrderManager(storeId);
                orderManager.clear();
            }
        });
        this.clearAll();
    };
    MultiOrderManager.prototype.getOrderItemsCount = function () {
        var _this = this;
        var count = 0;
        Object.keys(this.orderManagerMap).forEach(function (storeId) {
            var orderManager = _this.orderManagerMap[storeId];
            count += orderManager.count;
        });
        return count;
    };
    MultiOrderManager.prototype.isEmpty = function () {
        return !this.getOrders() || this.getOrders().length == 0;
    };
    MultiOrderManager = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [DiscountManager])
    ], MultiOrderManager);
    return MultiOrderManager;
}());
export { MultiOrderManager };
//# sourceMappingURL=multiordermanager.js.map